var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHollowTrashcan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7778 4.77808V4.27808H13.2778H1.94482H1.44482V4.77808V16.1111C1.44482 17.4308 2.51392 18.4999 3.83367 18.4999H11.389C12.7088 18.4999 13.7778 17.4308 13.7778 16.1111V4.77808Z",
    stroke: "#3CB4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3255 0.646438L10.179 0.5H9.97194H5.24988H5.04278L4.89634 0.646438L4.09833 1.4444H1H0.5V1.9444V3.83325V4.33325H1H14.2218H14.7218V3.83325V1.9444V1.4444H14.2218H11.1235L10.3255 0.646438Z",
    stroke: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHollowTrashcan);
export default __webpack_public_path__ + "static/media/hollowTrashcan.17ccd49a525f1431e170e1b3ece94dca.svg";
export { ForwardRef as ReactComponent };